// طريقة مركزية لقراءة نوع المنشأة مع fallback آمن — لا Migration في هذه المرحلة
export const ORGANIZATION_TYPES = {
  club: { key: 'club', label: 'نادي رياضي', shortLabel: 'نادي' },
  academy: { key: 'academy', label: 'أكاديمية رياضية', shortLabel: 'أكاديمية' },
};

export function getOrganizationType(club) {
  const raw = club?.organization_type || club?.club_type || club?.type;
  if (raw && ORGANIZATION_TYPES[raw]) return ORGANIZATION_TYPES[raw];
  // لا يوجد حقل مؤكد لنوع المنشأة حالياً — لا نفترض «نادي»
  return { key: 'club', label: 'منشأة رياضية', shortLabel: 'منشأة' };
}

export const FINANCE_ROLES = ['admin', 'super_admin', 'manager', 'treasurer'];

export function canViewFinance(user) {
  if (!user) return false;
  return user.is_super_admin || FINANCE_ROLES.includes(user.role);
}

export function canViewPayroll(user) {
  if (!user) return false;
  if (user.is_super_admin || FINANCE_ROLES.includes(user.role)) return true;
  return (user.financial_permissions || []).includes('view_payroll');
}

export function canRecordPayroll(user) {
  if (!user) return false;
  if (user.is_super_admin || FINANCE_ROLES.includes(user.role)) return true;
  return (user.financial_permissions || []).includes('record_payroll_payment');
}

export const ROLE_LABELS = {
  admin: 'مدير المنشأة',
  super_admin: 'مدير المنصة',
  coach: 'مدرب',
  analyst: 'محلل',
  manager: 'إداري',
  editor: 'محرر',
  moderator: 'مشرف',
  viewer: 'مشاهد',
  captain: 'قائد فريق',
  treasurer: 'أمين الصندوق',
  secretary: 'سكرتير',
};

export function getRoleLabel(role) {
  return ROLE_LABELS[role] || role || '';
}
